import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Global } from '../../shared/global';
import { Observable } from 'rxjs';
import { IEuroTaxResult } from '../models/eurotaxresult';
import { SettingsService } from './settings.service';
import { IEuroTaxResultMake } from '../models/eurotaxresultmake';

@Injectable({
  providedIn: 'root'
})
export class EurotaxService {

  constructor(private http: HttpClient, private settingsService: SettingsService) { }

  getList(nationalerCode: string, markenName: string, handelsBezeichnung: string, baujahr: number, leistung: number,
    antriebPrimary: string, vehicleTyp: number, tueren: number, bauart: string, hubraum: number): Observable<Array<IEuroTaxResult>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers };
    return this.http.get<Array<IEuroTaxResult>>(this.settingsService.settings.EurotaxServiceBaseUrl + Global.BASE_EUROTAX_ENDPOINT +
      `v3/list?` + (nationalerCode ? `nationalerCode=${nationalerCode}` : ``) + (markenName ? `&markenName=${markenName}` : ``) +
        (handelsBezeichnung ? `&handelsBezeichnung=${handelsBezeichnung}` : ``) + `&bauJahr=${baujahr}` + (leistung ? `&leistung=${leistung}` : ``) +
          (antriebPrimary ? `&antriebPrimary=${antriebPrimary}` : ``) + `&vehicleTyp=${vehicleTyp}` + (tueren ? `&tueren=${tueren}` : ``) +
          (bauart ? `&bauart=${bauart}` : ``) + (hubraum ? `&hubraum=${hubraum}` : ``), options);
  }

  getMakes(vehicleTyp: number, baujahr: number): Observable<Array<IEuroTaxResultMake>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers };
    return this.http.get<Array<IEuroTaxResultMake>>(this.settingsService.settings.EurotaxServiceBaseUrl + Global.BASE_EUROTAX_ENDPOINT +
      `makes?vehicleTyp=${vehicleTyp}&bauJahr=${baujahr}`, options);
  }

  pingService(): Observable<any>{
   return this.http.get<any>(this.settingsService.settings.EurotaxServiceBaseUrl + Global.BASE_EUROTAX_ENDPOINT + 'v3/list' , {observe: 'response'});
  }

}
